import { useParams } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'
import { F0Text } from '@factorialco/f0-react'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import { ContentThumbnail } from 'modules/trainings/components/content/items/shared/fields/ContentThumbnail'
import { InlineEditableDescription } from 'modules/trainings/components/content/items/shared/fields/InlineEditableDescription'
import { InlineEditableTitle } from 'modules/trainings/components/content/items/shared/fields/InlineEditableTitle'
import { contentContainer } from 'modules/trainings/components/content/styles.vanilla.css'
import { titleStyle } from 'modules/trainings/components/content/styles.vanilla.css'
import { AttachedFile } from 'modules/trainings/lib/content/AttachedFile'
import { PageBlock } from 'modules/trainings/lib/content/PageBlock'

type PageBlockViewProps = {
  contentItem: PageBlock
  isFullscreen?: boolean
  readOnly?: boolean
  onContentChange?: () => void
}

export const PageBlockView = observer(
  ({ contentItem, readOnly = false, onContentChange }: PageBlockViewProps) => {
    const { id: trainingId } = useParams()

    const handleTitleChange = (value: string) => {
      contentItem.title = value
      onContentChange?.()
    }

    const handleDescriptionChange = (value: string) => {
      contentItem.description = value
      onContentChange?.()
    }

    const handleThumbnailChange = (thumbnail: AttachedFile) => {
      contentItem.thumbnail = thumbnail
      onContentChange?.()
    }

    const handleThumbnailDelete = () => {
      contentItem.thumbnail.clear()
      onContentChange?.()
    }

    return (
      <Box gap="s16" width="full" alignItems="center" paddingTop="s8">
        <ContentThumbnail
          thumbnail={contentItem.thumbnail}
          readOnly={readOnly}
          trainingId={trainingId || ''}
          description={i18n.t('trainings.content.block.page.thumbnail_description')}
          title={contentItem.title}
          onChange={handleThumbnailChange}
          onDelete={handleThumbnailDelete}
        />

        <Box width="full" gap="s24" className={contentContainer}>
          {readOnly ? (
            <F0Text content={contentItem.title} variant="body" style={titleStyle} />
          ) : (
            <InlineEditableTitle
              value={contentItem.title}
              placeholder={i18n.t('trainings.content.block.page.title_placeholder')}
              ariaLabel={i18n.t('trainings.content.block.page.title_label')}
              onChange={handleTitleChange}
              style={titleStyle}
            />
          )}
          <InlineEditableDescription
            value={contentItem.description}
            readOnly={readOnly}
            editorKey={contentItem.uuid}
            placeholder={i18n.t('trainings.content.block.page.description_placeholder')}
            onChange={handleDescriptionChange}
          />
        </Box>
      </Box>
    )
  }
)
